export enum DocumentFileType {
	Attachment="ATTACHMENT",
	Body="BODY",
	DocumentSource="DOCUMENT_SOURCE"
	}
